import * as React from "react"

import { cn } from "../../utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content !min-h-16 w-full !rounded-lg !border !border-gray-200 !bg-gray-100 !px-3 !py-2 !text-sm !text-gray-700 !shadow-none transition-[color,box-shadow,border-color] !outline-none !placeholder:text-input-placeholder disabled:cursor-not-allowed disabled:opacity-50 resize-y !mb-0",
        "focus-visible:!border-blue-500 focus-visible:!ring-0",
        "aria-invalid:!border-rose-600 aria-invalid:!ring-0",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
